import { useMutation, useQueryClient } from '@tanstack/react-query';

import ReservationService from '~/services/ReservationService';

import { amenityQueryKeys } from './amenityQueryKeys';

interface CreateAmenityData {
  name: string;
  builtIn?: boolean;
}

export function useCreateAmenity() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ name, builtIn = false }: CreateAmenityData) => {
      return await ReservationService.createAmenity(name, builtIn);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: amenityQueryKeys.all });
    },
  });
}
